import Vue from 'vue'
import Vuex from 'vuex'
import state from './modules/state'
import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    state
  },
  getters
})
